import React, { useEffect, useRef } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Footer from "./components/Footer";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import SendSmsPage from "./pages/SendSmsPage";
import SmsReportPage from "./pages/SmsReportPage";
import Navbar from "./components/Navbar";
import { useAuth } from "./AuthContext";

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
}

export default function App() {
  const { user, logout } = useAuth();
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      if (user) {
        logout();
      }
    }, 5 * 60 * 1000); // 5 Minutes
  };

  useEffect(() => {
    if (user) {
      const events = [
        "mousedown",
        "mousemove",
        "keypress",
        "scroll",
        "touchstart",
      ];
      resetTimer();
      events.forEach((event) => window.addEventListener(event, resetTimer));
      return () => {
        events.forEach((event) =>
          window.removeEventListener(event, resetTimer)
        );
        if (timerRef.current) clearTimeout(timerRef.current);
      };
    }
  }, [user]);

  return (
    <div className="min-h-screen flex flex-col">
      {/* 1. Navbar is outside Routes: Always visible */}
      <Navbar />

      <main className="flex-grow container mx-auto px-4 py-6">
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/send-sms"
            element={
              <PrivateRoute>
                <SendSmsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/report"
            element={
              <PrivateRoute>
                <SmsReportPage />
              </PrivateRoute>
            }
          />
        </Routes>
      </main>

      {/* 2. Footer is outside Routes: Always visible */}
      <Footer />
    </div>
  );
}
